// extracted by mini-css-extract-plugin
export var checkbox = "_67-0";
export var circle = "_67-3";
export var horizontalContainer = "_67-7";
export var sm = "_67-5";
export var switch0 = "_67-2";
export var switchDisabled = "_67-8";
export var switchEnabled = "_67-1";
export var textSwitchContainer = "_67-9";
export var textSwitchOption = "_67-a";
export var textSwitchOptionSelected = "_67-b";
export var verticalContainer = "_67-6";
export var xs = "_67-4";